"use strict";

define('app/template/edit/template.edit.controller',['rs/abstract.content.controller', 'app/template/edit/template.edit.view', 'rs/form/factory', 'rs/models/session', 'e3-modal'], function (AbstractContentController, TemplateEditView, FormFactory, Session, E3Modal) {
  var TemplateEditController = AbstractContentController.extend({
    contentName: 'template-edit-content',
    properties: ['formDesignerController', 'initialSectionIndex'],
    observes: {
      'heartbeatRespondedWithUNLOCK': 'heartbeatUnlockRequested'
    },
    events: {
      'view:ready': 'render'
    },
    setupView: function setupView() {
      this.setView(new TemplateEditView());
    },
    start: function start(id, revision, section) {
      var preview = document.location.hash.indexOf("preview") > -1;
      this.setInitialSectionIndex(section);
      return Promise.resolve(FormFactory.createFormEditor(id, revision, preview)).bind(this).tap(this.formDidLoad).fail(this.formDidFail);
    },
    heartbeatUnlockRequested: function heartbeatUnlockRequested() {
      if (!this.showingWarning) {
        E3Modal.BtnMsgModal.show({
          title: 'Warning',
          message: 'You will lose your changes on the open template if your session remains inactive.',
          buttons: 'Ok'
        }).bind(this).lastly(function () {
          this.showingWarning = null;
        });
        this.showingWarning = true;
      }
    },
    formDidLoad: function formDidLoad(formController) {
      var view = this.getView();
      this.setFormDesignerController(formController);
      formController.setAppController(this.getAppController());
      formController.setInitialSectionIndex(this.getInitialSectionIndex());
      formController.setup(view.getFormContainerElement());
      this.updateDocumentTitle();
    },
    hasVolatileData: function hasVolatileData() {
      var fc = this.getFormDesignerController();
      if (fc) {
        return fc.getUnsavedChanges();
      } else {
        return false;
      }
    },
    unloadContentController: function unloadContentController() {
      return this.formDesignerController.unlockModels();
    },
    requestPageSave: function requestPageSave() {
      var self = this;
      return this.getFormDesignerController().requestSaveAction().then(function () {
        return self.getFormDesignerController().unlockModels();
      });
    },
    getDocumentTitle: function getDocumentTitle() {
      var formDesignerController = this.getFormDesignerController();
      if (formDesignerController) {
        return 'Template - ' + formDesignerController.getTemplateModel().title;
      }
    },
    formDidFail: function formDidFail(err) {},
    unload: function unload() {
      Session.triggerActivity('templateId', null);
      this._super();
      if (this.formDesignerController) {
        return this.formDesignerController.unload();
      }
    },
    destroy: function destroy() {
      if (this.formDesignerController) {
        return this.formDesignerController.destroy();
      }
      this._super();
    }
  }, {
    requiredPermissions: ['EFORMS_MODIFY_TEMPLATE']
  });
  return TemplateEditController;
});

